import React from 'react';
import PropTypes from 'prop-types';
import { ProgressMeter } from '@paypalcorp/pp-react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var GoalProgressMeter = function GoalProgressMeter(_ref) {
  var max = _ref.max,
    value = _ref.value,
    steps = _ref.steps,
    title = _ref.title,
    className = _ref.className;
  var classObj = className ? {
    className: className
  } : {};
  return /*#__PURE__*/React.createElement(ProgressMeter, _extends({
    max: max,
    value: value,
    steps: steps,
    title: title
  }, classObj));
};
GoalProgressMeter.propTypes = {
  max: PropTypes.string,
  value: PropTypes.string,
  steps: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string
};

export { GoalProgressMeter };
